import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';

export const planTypeToggleDropDownStyles = {
	planTypeToggle: {
		borderRadius: '50px',
		border: `1px solid ${colorPalette.dark3}`,
	},
	planTypeTab: {
		...reusableStyles.flexRowWithGap(4),
		justifyContent: 'center',
		cursor: 'pointer',
		flex: 1,
		padding: { xs: '6px 24px', sm: '12px 32px' },
	},
	planTypeTabBadge: {
		borderRadius: '2px',
		padding: '2px 12px',

		backgroundColor: 'colors.purple4',
		color: 'colors.light2',
	},

	planTypeDropdown: {
		width: '232px',
		padding: '6px 12px',
		borderRadius: '4px',

		backgroundColor: colorPalette.dark3,

		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: '8px',

		textTransform: 'none',

		'&:hover': {
			backgroundColor: colorPalette.dark3,
		},
	},
	planTypePopOver: {
		width: '232px',
		padding: '12px',
		borderRadius: '4px',

		backgroundColor: colorPalette.dark3,

		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
	},
};
